import { Controller } from "@hotwired/stimulus"

// The Recipients table of the Schedule and Send step. Switching the free preview on or off changes only the
// Free row's badge and the total, both known from the page, so the table follows without a reload. The switch
// itself is saved by auto-save (see PostsController#publish).
export default class extends Controller {
  static targets = ["toggle", "total", "previewBadge", "offBadge"]
  static values = { fullCount: Number, freeCount: Number }

  update() {
    const on = this.hasToggleTarget && this.toggleTarget.checked;
    this.previewBadgeTargets.forEach(badge => badge.classList.toggle("hidden", !on));
    this.offBadgeTargets.forEach(badge => badge.classList.toggle("hidden", on));

    const total = this.fullCountValue + (on ? this.freeCountValue : 0);
    this.totalTarget.textContent = `${total.toLocaleString("en-US")} ${total === 1 ? "subscriber" : "subscribers"}`;
  }
}
